import { NotFoundMessage } from '@hendrx/core/common/components/messages/PageMessage/Messages/NotFoundMessage';
import { TemplatesPage, useGetTemplatesPermissionsQuery } from '@hendrx/core/templates';
import { createFileRoute } from '@tanstack/react-router';

import { CustomLoadingOverlay } from 'shared/components/app/CustomLoadingOverlay';

export const Route = createFileRoute('/studio/templates')({
  component: TemplatesPageWrapper
});

function TemplatesPageWrapper() {
  const { data: templatesPermissionsData, isLoading } = useGetTemplatesPermissionsQuery();

  if (isLoading) {
    return <CustomLoadingOverlay visible />;
  }

  return templatesPermissionsData?.canManage ? <TemplatesPage /> : <NotFoundMessage />;
}
